module.exports = __webpack_public_path__ + "img/clock.a80e8858.svg";